var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___V2VvNG",
  "Un": "AuthPageStyles.module__errorContainer___V2VvNG",
  "ik": "AuthPageStyles.module__errorIcon___V2VvNG",
  "gi": "AuthPageStyles.module__errorIconSvg___V2VvNG",
  "JU": "AuthPageStyles.module__errorTitle___V2VvNG",
  "kc": "AuthPageStyles.module__errorText___V2VvNG",
  "kL": "AuthPageStyles.module__container___V2VvNG",
  "TQ": "AuthPageStyles.module__entityHeader___V2VvNG",
  "Ep": "AuthPageStyles.module__entityDetails___V2VvNG",
  "Pp": "AuthPageStyles.module__entityText___V2VvNG",
  "j2": "AuthPageStyles.module__entityTitleWrapper___V2VvNG",
  "wD": "AuthPageStyles.module__entityTitle___V2VvNG",
  "N2": "AuthPageStyles.module__entityStats___V2VvNG",
  "So": "AuthPageStyles.module__entityStat___V2VvNG",
  "RS": "AuthPageStyles.module__onlineDot___V2VvNG",
  "FD": "AuthPageStyles.module__offlineDot___V2VvNG",
  "KA": "AuthPageStyles.module__statText___V2VvNG",
  "Wp": "AuthPageStyles.module__entityIconWrapper___V2VvNG",
  "fq": "AuthPageStyles.module__entityIcon___V2VvNG",
  "Ly": "AuthPageStyles.module__themeIconSpot___V2VvNG",
  "J3": "AuthPageStyles.module__themeIcon___V2VvNG",
  "Zd": "AuthPageStyles.module__form___V2VvNG",
  "ee": "AuthPageStyles.module__registrationNotice___V2VvNG",
  "Gr": "AuthPageStyles.module__bottomLink___V2VvNG",
  "fH": "AuthPageStyles.module__bottomLinkText___V2VvNG",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___V2VvNG",
  "cB": "AuthPageStyles.module__usernameHint___V2VvNG",
  "Jy": "AuthPageStyles.module__suggestionLink___V2VvNG",
  "LB": "AuthPageStyles.module__usernameError___V2VvNG",
  "$M": "AuthPageStyles.module__consentRow___V2VvNG",
  "t6": "AuthPageStyles.module__consentLabel___V2VvNG",
  "Rf": "AuthPageStyles.module__policyLink___V2VvNG",
  "ii": "AuthPageStyles.module__disabledContainer___V2VvNG",
  "aV": "AuthPageStyles.module__disabledText___V2VvNG",
  "ax": "AuthPageStyles.module__disabledSubtext___V2VvNG",
  "SO": "AuthPageStyles.module__disabledActions___V2VvNG",
  "ns": "AuthPageStyles.module__disabledActionLink___V2VvNG",
  "DD": "AuthPageStyles.module__title___V2VvNG",
  "Zo": "AuthPageStyles.module__giftIconContainer___V2VvNG",
  "ez": "AuthPageStyles.module__giftIcon___V2VvNG",
  "PM": "AuthPageStyles.module__entitySubtext___V2VvNG",
  "W$": "AuthPageStyles.module__subtext___V2VvNG",
};

module.exports = exports;
